import { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import Organograma from '../../../Organograma';
import Lgpd from '../../../Lgpd';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../../InfoComponent';

class OrganogramaPage extends Component {
	render() {
		return (
			<div>
				{/* <script src="../../../../assets/js/src/components/organograma.js"></script> */}
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={"organograma"} page={'organograma'}></InfoComponent>

				{/* Organograma */}
				<ErrorBoundary><Organograma /></ErrorBoundary>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default OrganogramaPage;